<template>
    <div class="hjalpmedel">
        <admin-lock-border />
        <div class="header">
            <h1>Hjälpmedel</h1>
            <CustomButton type="button" variant="hollow" @click="openCreateHjalpmedel">
                <img src="@/assets/plus_circle_blue.svg" />
                <span>Skapa nytt hjälpmedel</span>
            </CustomButton>
        </div>

        <kliniken-table
            v-if="hjalpmedel.results"
            :items="hjalpmedel.results"
            paginationStyle="paging"
            :columns="columns"
            :count="count"
            :limit="limit"
            :currentPage="currentPage"
            @loadPage="loadPage"
            @changeLimit="changeLimit"
            @loadMore="loadMore"
            :showBottom="true"
            :showLimitDropdown="true"
            :has-dropdown="true"
            :dropdown-actions="dropdownActions"
            @editHjalpmedel="editHjalpmedelFromTable"
        />
    </div>
</template>

<script>
    import tabIcon from "@/assets/gear.svg";

    export default {
        name: "HjalpmedelList",
        tabName: "Hjälpmedel",
        icon: tabIcon,
    };
</script>

<script setup>
    import { onMounted, ref, onBeforeUnmount } from "vue";
    import emitter from "tiny-emitter/instance";
    import { openDialog } from "@/utils";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import { getConfig, klinikenApi } from "@/api";
    import KlinikenTable from "@/components/Table/KlinikenTable.vue";
    import CustomButton from "@/components/Button.vue";
    import HjalpmedelForm from "./HjalpmedelForm.vue";
    import store from "@/store";

    const hjalpmedel = ref([]);
    const count = ref(0);
    const columns = ref([
        {
            title: "Namn",
            name: "displayName",
        },
    ]);
    const dropdownActions = ref([
        {
            name: "editHjalpmedel",
            title: "Redigera hjälpmedel",
            show: () => true,
        },
    ]);

    const limit = ref(50);
    const offset = ref(0);
    const fetchBatch = ref(1);
    const params = ref({});
    const currentPage = ref(1);

    const loadPage = async (page) => {
        currentPage.value = page;
        offset.value = (page - 1) * limit.value;
        await fetchHjalpmedel();
    };

    const loadMore = async () => {
        fetchBatch.value++;
        await fetchHjalpmedel();
    };

    const changeLimit = async (dropdownLimit) => {
        fetchBatch.value = 1;
        limit.value = dropdownLimit;
        await fetchHjalpmedel();
    };

    const fetchHjalpmedel = async () => {
        params.value = { ...params.value, limit: limit.value, offset: offset.value };
        if (limit.value > 0) {
            params.value["limit"] = limit.value * fetchBatch.value;
        }
        try {
            const response = await klinikenApi.get(
                "/operation/kodverk/hjalpmedel/",
                getConfig({ params: { ...params.value } })
            );
            hjalpmedel.value = response.data;
            count.value = response.data.count;
        } catch (error) {
            openDialog("Kunde inte hämta Hjälpmedel.", "warning");
        }
    };

    const openCreateHjalpmedel = () => {
        store.dispatch("tabs/openTab", {
            component: HjalpmedelForm,
            parameters: { redigera: false },
        });
    };

    const editHjalpmedelFromTable = (hjalpmedel) => {
        store.dispatch("tabs/openTab", {
            component: HjalpmedelForm,
            parameters: {
                redigera: true,
                hjalpmedel,
            },
        });
    };

    onMounted(() => {
        fetchHjalpmedel();
        emitter.on("refreshHjalpmedel", fetchHjalpmedel);
    });

    onBeforeUnmount(() => {
        emitter.off("refreshHjalpmedel", fetchHjalpmedel);
    });
</script>
<style lang="scss">
    .hjalpmedel {
        .header {
            h1 {
                margin: 0;
            }

            display: flex;
            gap: 20px;
            align-items: center;
        }
    }
</style>
